import { Store } from 'redux';

import { TRootState } from '../common/reducers';

type UnsubscribeCallback = () => void;

const trustedSourcesRegexp = /^(https:\/\/support\.wix\.com|https:\/\/(.+)\.support\.com|https?:\/\/localhost(:\d+)?)$/i;

type CopilotMessageData = {
  type: string;
  event: string;
  query: string;
  payload: Record<string, any>;
};

const createOnMessageHandler =
  (sendMessageCallback: (message: string) => void) =>
  ({ origin, data, source }: MessageEvent<CopilotMessageData>): void => {
    const isTrustedSources = trustedSourcesRegexp.test(origin);
    const isCopilotType = data && data.type === 'COPILOT_CHATBOT';

    if ((!isTrustedSources && source !== window) || !isCopilotType) {
      return;
    }

    const { event, query } = data;
    switch (event) {
      case 'pre_message_send':
        sendMessageCallback(query);
        break;
      default:
        throw new Error(`Unknown event: ${event}`);
    }
  };

export const subscribeCopilotToMessages = (
  _store: Store<TRootState>,
  sendMessageCallback: (message: string) => void,
): UnsubscribeCallback => {
  const onMessage = createOnMessageHandler(sendMessageCallback);
  window.addEventListener('message', onMessage);

  return () => window.removeEventListener('message', onMessage);
};
